import { DateField } from "@mui/x-date-pickers"
import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../app/hooks"
import { editPolicyDetails } from "../../../../services/caseManService/model/policy/PolicySlice";
import { ReduxUpdate } from "../../../../utils/ReduxUpdateCommands";
import dayjs from "dayjs";

function PolicyReviewDateEdit() {
    const dispatch = useAppDispatch();
    const policy = useAppSelector((state) => state.policy.policy);

    return <React.Fragment>
        <DateField label='Policy Review Date' value={dayjs(policy.reviewDate)}
            onChange={(e)=>dispatch(editPolicyDetails(new ReduxUpdate('reviewDate',e)))}/>
    </React.Fragment>
}
export {PolicyReviewDateEdit}